/* Baby 392 King — storefront behaviour */
(function () {
  "use strict";

  /* ---------------- toast ---------------- */
  var toast = document.getElementById("toast");
  var toastMsg = document.getElementById("toastMsg");
  var tTimer;
  function say(msg) {
    if (!toast) return;
    toastMsg.textContent = msg;
    toast.classList.add("show");
    clearTimeout(tTimer);
    tTimer = setTimeout(function () { toast.classList.remove("show"); }, 2800);
  }

  /* ---------------- mobile nav ---------------- */
  var burger = document.getElementById("burger");
  if (burger) {
    burger.addEventListener("click", function () {
      var m = document.getElementById("mnav");
      var open = m.classList.toggle("open");
      burger.setAttribute("aria-expanded", open ? "true" : "false");
    });
  }

  /* ---------------- scroll reveal ---------------- */
  var ticking = false;
  function reveal() {
    ticking = false;
    var h = window.innerHeight;
    var nodes = document.querySelectorAll(".rv:not(.in)");
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].getBoundingClientRect().top < h * 0.92) nodes[i].classList.add("in");
    }
  }
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(reveal); } }
  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", onScroll, { passive: true });
  reveal();

  /* ---------------- hero carousel ---------------- */
  var cxRoot = document.getElementById("cx");
  if (cxRoot) {
    var slides = Array.prototype.slice.call(cxRoot.querySelectorAll(".cx-slide"));
    var dotsWrap = document.getElementById("cxDots");
    var numOut = document.getElementById("cxNum");
    var reduceMo = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var autoplay = cxRoot.getAttribute("data-autoplay") !== "false";
    var DUR = (parseInt(cxRoot.getAttribute("data-speed"), 10) || 6) * 1000;
    var i = 0, timer = null, dots = [];

    cxRoot.style.setProperty("--cx-dur", DUR / 1000 + "s");

    if (dotsWrap && slides.length > 1) {
      slides.forEach(function (_, n) {
        var b = document.createElement("button");
        b.type = "button";
        b.className = "cx-dot" + (n === 0 ? " on" : "");
        b.setAttribute("aria-label", "Show slide " + (n + 1));
        b.innerHTML = "<i></i>";
        b.addEventListener("click", function () { go(n); restart(); });
        dotsWrap.appendChild(b);
        dots.push(b);
      });
    }

    function go(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle("on", k === i); });
      dots.forEach(function (d) { d.classList.remove("on", "paused"); d.firstChild.style.width = ""; });
      if (dots[i]) {
        var d = dots[i];
        void d.offsetWidth;
        d.classList.add("on");
        if (reduceMo || !autoplay) d.classList.add("paused");
      }
      if (numOut) numOut.textContent = ("0" + (i + 1)).slice(-2);
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() {
      if (reduceMo || !autoplay || slides.length < 2) return;
      stop();
      timer = setInterval(function () { go(i + 1); }, DUR);
    }
    function restart() { stop(); start(); }
    function freeze() {
      if (dots[i]) { var f = dots[i].firstChild; var wpx = getComputedStyle(f).width; dots[i].classList.add("paused"); f.style.width = wpx; }
      stop();
    }
    function thaw() {
      if (dots[i]) { var f = dots[i].firstChild; dots[i].classList.remove("paused"); f.style.width = ""; }
      start();
    }
    cxRoot.addEventListener("mouseenter", freeze);
    cxRoot.addEventListener("mouseleave", thaw);
    cxRoot.addEventListener("focusin", freeze);
    cxRoot.addEventListener("focusout", thaw);

    var prev = document.getElementById("cxPrev"), next = document.getElementById("cxNext");
    if (prev) prev.addEventListener("click", function () { go(i - 1); restart(); });
    if (next) next.addEventListener("click", function () { go(i + 1); restart(); });
    cxRoot.addEventListener("keydown", function (e) {
      if (e.key === "ArrowLeft") { go(i - 1); restart(); }
      if (e.key === "ArrowRight") { go(i + 1); restart(); }
    });
    var sx = null;
    cxRoot.addEventListener("pointerdown", function (e) { sx = e.clientX; });
    cxRoot.addEventListener("pointerup", function (e) {
      if (sx === null) return;
      var dx = e.clientX - sx; sx = null;
      if (Math.abs(dx) > 45) { go(i + (dx < 0 ? 1 : -1)); restart(); }
    });
    start();
  }

  /* ---------------- product page ---------------- */
  var pform = document.getElementById("pform");
  if (pform) {
    var qty = document.getElementById("qty");
    var minus = document.getElementById("qMinus"), plus = document.getElementById("qPlus");
    if (minus) minus.addEventListener("click", function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1); });
    if (plus) plus.addEventListener("click", function () { qty.value = (parseInt(qty.value, 10) || 1) + 1; });

    var variants = [];
    var vdata = document.getElementById("variantData");
    if (vdata) { try { variants = JSON.parse(vdata.textContent); } catch (e) { variants = []; } }

    var groups = Array.prototype.slice.call(pform.querySelectorAll(".opt-group"));
    var idField = document.getElementById("variantId");
    var priceOut = document.getElementById("pdpPrice");
    var atc = document.getElementById("atc");
    var atcLabel = document.getElementById("atcLabel");

    function chosen() {
      return groups.map(function (g) {
        var on = g.querySelector(".opt.on");
        return on ? on.getAttribute("data-value") : null;
      });
    }
    function money(cents) {
      return "$" + (cents / 100).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
    function sync() {
      if (!variants.length || !groups.length) return;
      var want = chosen();
      var match = variants.filter(function (v) {
        return want.every(function (val, n) { return val === null || v.options[n] === val; });
      })[0];
      if (!match) return;
      if (idField) idField.value = match.id;
      if (priceOut) {
        var note = priceOut.querySelector("small");
        priceOut.textContent = money(match.price);
        if (note) priceOut.appendChild(note);
      }
      if (atc) {
        atc.disabled = !match.available;
        if (atcLabel) atcLabel.textContent = match.available ? "Add to cart" : "Sold out";
      }
      try {
        var u = new URL(window.location.href);
        u.searchParams.set("variant", match.id);
        window.history.replaceState({}, "", u.toString());
      } catch (e) {}
    }

    groups.forEach(function (g) {
      g.addEventListener("click", function (e) {
        var b = e.target.closest(".opt");
        if (!b) return;
        g.querySelectorAll(".opt").forEach(function (x) { x.classList.remove("on"); });
        b.classList.add("on");
        var out = g.querySelector("[data-out]");
        if (out) out.textContent = b.getAttribute("data-value");
        sync();
      });
    });

    var thumbs = Array.prototype.slice.call(document.querySelectorAll(".thumbs .ph"));
    var mainImg = document.getElementById("pdpImg");
    thumbs.forEach(function (t) {
      t.addEventListener("click", function () {
        thumbs.forEach(function (x) { x.classList.remove("on"); });
        t.classList.add("on");
        if (mainImg) mainImg.src = t.getAttribute("data-full");
      });
    });

    // add to cart without a page reload
    pform.addEventListener("submit", function (e) {
      if (!window.fetch) return;
      e.preventDefault();
      var body = new FormData(pform);
      atc.disabled = true;
      fetch("/cart/add.js", { method: "POST", body: body, headers: { "Accept": "application/json" } })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          atc.disabled = false;
          if (!res.ok) { say(res.j.description || "Couldn't add that to the cart"); return; }
          say("Added — " + res.j.product_title);
          return fetch("/cart.js", { headers: { "Accept": "application/json" } })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              var n = document.getElementById("cartN");
              if (n) n.textContent = cart.item_count;
            });
        })
        .catch(function () { atc.disabled = false; pform.submit(); });
    });
  }
})();
